import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/img/logo2-inverse.svg'
import _imports_1 from '@/assets/img/logo_secondary_full.png'


const _hoisted_1 = {
  key: 0,
  class: "d-header__logo",
  src: _imports_0,
  alt: "logo"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  class: "d-header__logo",
  src: _imports_1,
  alt: "logo"
}, null, -1)
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "d-userbar__name" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "icon icon-caret" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_app_search = _resolveComponent("app-search")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_app_header = _resolveComponent("app-header")!

  return (_openBlock(), _createBlock(_component_app_header, null, {
    left: _withCtx(() => [
      _createVNode(_component_router_link, {
        to: "/",
        class: "d-header__logo-link"
      }, {
        default: _withCtx(() => [
          false
            ? (_openBlock(), _createElementBlock("img", _hoisted_1))
            : _createCommentVNode("", true),
          _hoisted_2
        ]),
        _: 1
      })
    ]),
    middle: _withCtx(() => [
      (_ctx.currentPage === _ctx.NAVIGATION_PAGES.MESSAGES_MY || _ctx.currentPage === _ctx.NAVIGATION_PAGES.MESSAGES_ID)
        ? (_openBlock(), _createBlock(_component_app_search, {
            key: 0,
            class: "d-header__search",
            modelValue: _ctx.spacesStore.search,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.spacesStore.search) = $event)),
            onClear: _cache[1] || (_cache[1] = ($event: any) => (_ctx.spacesStore.search = ''))
          }, null, 8, ["modelValue"]))
        : (_ctx.currentPage === _ctx.NAVIGATION_PAGES.SPACES_CONTACTS || _ctx.currentPage === _ctx.NAVIGATION_PAGES.SPACES_GROUPS_MAIN)
          ? (_openBlock(), _createBlock(_component_app_search, {
              key: 1,
              modelValue: _ctx.spacesStore.search,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.spacesStore.search) = $event)),
              onClear: _cache[3] || (_cache[3] = ($event: any) => (_ctx.spacesStore.search = '')),
              placeholder: _ctx.$localize(_ctx.searchPlaceholder)
            }, null, 8, ["modelValue", "placeholder"]))
          : (_openBlock(), _createBlock(_component_app_search, {
              key: 2,
              class: "d-header__search",
              modelValue: _ctx.driveStore.search,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.driveStore.search) = $event)),
              onClear: _cache[5] || (_cache[5] = ($event: any) => (_ctx.driveStore.search = ''))
            }, null, 8, ["modelValue"]))
    ]),
    right: _withCtx(() => [
      _createVNode(_component_el_dropdown, { class: "dropdown-menu" }, {
        dropdown: _withCtx(() => [
          _createVNode(_component_el_dropdown_menu, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_dropdown_item, null, {
                default: _withCtx(() => [
                  _createElementVNode("button", {
                    onClickOnce: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.logOut && _ctx.logOut(...args))),
                    class: "logout-btn"
                  }, " Log Out ", 32)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("img", {
            class: "d-userbar__image",
            src: _ctx.photoUrl,
            alt: "",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.navigateTo('/profile')))
          }, null, 8, _hoisted_3),
          _createElementVNode("span", _hoisted_4, [
            _createTextVNode(_toDisplayString(_ctx.fullName) + " ", 1),
            _hoisted_5
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}